// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.ongoingcare.UpdatePatientOngoingCareRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePatientOngoingCareRequest extends GandalfModelBase {

	@GandalfLabel('Glaucoma Care Comments')
	@GandalfValidator({ sizeString: { message: 'Glaucoma Care Comments cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	glaucomaCareComment!: string | null;

	@GandalfLabel('Patient Ongoing Care')
	@GandalfValidator({ notNull: { message: 'Patient Ongoing Care is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientOngoingCareId!: number;

}
